module.exports = __webpack_public_path__ + "img/banner-flexben.41cc6eb2.png";